import { PanelTabType, PanelType } from "../../Panel/PanelTypes";

export enum HiddenPanelActionType {
    SetPanelState = "SET_PANEL_STATE",
    SetWidePanel = "SET_WIDE_PANEL",
    SetPopupPanel = "SET_POPUP_PANEL",
    FrozenPanel = "FROZEN_PANEL",
    SetPanelActiveTab = "SetPanelActiveTab",
}

export type HiddenPanelAction =
    | { type: HiddenPanelActionType.SetPanelState; payload: PanelType }
    | { type: HiddenPanelActionType.SetWidePanel; payload: boolean }
    | {
          type: HiddenPanelActionType.SetPopupPanel;
          payload: { isPopupPanel: boolean; isFrozenPopup: undefined | boolean };
      }
    | { type: HiddenPanelActionType.FrozenPanel; payload: boolean }
    | { type: HiddenPanelActionType.SetPanelActiveTab; payload: PanelTabType };
